import noDataImage from "../../assets/img/noData.png";
function NoDataFound() {
  return (
    <div className="w-full justify-center items-center flex flex-col p-8">
      <img className=" w-20 h-20" src={noDataImage} alt="no_data_image" />
      <div className="font-bold mt-4 text-gray-300 text-2xl">No Data Found</div>
    </div>
  );
}
export default NoDataFound;
